import es6Promise, {Promise} from 'es6-promise'
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import API from '@/services/API.js';
import VueLocalStorage from 'vue-localstorage'
import fr from 'vee-validate/dist/locale/fr';
import en from 'vee-validate/dist/locale/en';
import it from 'vee-validate/dist/locale/it';
import VeeValidate, { Validator } from 'vee-validate';
import Vuelidate from 'vuelidate'
import moment from 'moment';
import frLocale from 'moment/locale/fr';
import esLocale from 'moment/locale/es';
import itLocale from 'moment/locale/it';
import { populateTimeZones } from 'timezone-support/lookup-convert';
import data from 'timezone-support/data-2012-2022'
import Vue2Filters from 'vue2-filters'
import Utils from '@/services/utils.js'
import GoogleAuth from 'vue-google-auth'
import { i18n } from './setup/i18n-setup';
import VueTelInput from 'vue-tel-input'
import Auth from '@/services/auth.js'
import { BootstrapVue } from 'bootstrap-vue'
import VueMatomo from 'vue-matomo'

Vue.config.devtools = true

es6Promise.polyfill()

Utils.setTheme()

Validator.updateDictionary(
    {
        fr:{
            messages: fr.messages
        },
        en: {
            messages: en.messages
        },
        it: {
            messages: it.messages
        }
    }
);

Vue.use(VueLocalStorage);
Vue.use(VeeValidate, {
    locale: 'fr',
    delay: 0,
    enableAutoClasses: true,
});
Vue.use(Vue2Filters);
Vue.use(GoogleAuth, { clientId: '500659461825-27ch3tu9hh4jjhm9oahgdq18h1pqhfso.apps.googleusercontent.com' })
Vue.googleAuth().load()

// Can pass en/fr/es/it as moment locale
moment.locale('fr', [
    frLocale,
    esLocale,
    itLocale
]);

// Used for TimezonePicker
populateTimeZones(data);

//Vue Tel Input
Vue.use(VueTelInput)

// Make BootstrapVue available throughout the project
Vue.use(BootstrapVue)

Vue.use(Vuelidate);

Vue.use(VueMatomo, {
    // Configurez votre instance Matomo en renseignant
    host: 'https://analysis.suivideflotte.net',
    siteId: process.env.MATOMO_SITE_ID || ''
})
window._paq.push(['trackPageView']); // Pour suivre les visites sur vos pages

Vue.config.productionTip = false
Vue.config.devtools = process.env.NODE_ENV === 'development'
Vue.config.debug = process.env.NODE_ENV === 'development'
Vue.config.silent = !(process.env.NODE_ENV === 'development')

var vm = new Vue({
    el: '#app',
    router,
    i18n,
    template: '<App :acl="acl"/>',
    components: {App},
    data:() => ({
        loginMode: true,
        acl: {
            "hub": {
                "beepiz": false,
                "bom": false,
                "car_sharing": false,
                "gestion_parc": false,
                "mission": false,
                "portail": false,
                "suivi_vision": false,
                "support": false
            },
            "capabilities": {
                "dashboard": {
                    "show": 0
                },
                "reports": {
                    "show": 0
                },
                "plans":{
                    "manager": {
                        "show": 0,
                        "add": 0,
                        "edit": 0,
                        "delete": 0
                    },
                    "library": {
                        "show": 0,
                        "add": 0,
                        "edit": 0,
                        "delete": 0
                    }
                },
                "devices":{
                    "devices": {
                        "show": 0,
                        "add": 0,
                        "edit": 0,
                        "delete": 0
                    },
                    "groups": {
                        "show": 0,
                        "add": 0,
                        "edit": 0,
                        "delete": 0
                    },
                    "licences": {
                        "show": 0,
                        "add": 0,
                        "edit": 0,
                        "delete": 0
                    }
                },
                "profiles":{
                    "profiles": {
                        "show": 0,
                        "add": 0,
                        "edit": 0,
                        "delete": 0
                    },
                    "phonebooks": {
                        "show": 0,
                        "add": 0,
                        "edit": 0,
                        "delete": 0
                    }
                },
                "identifications": {
                    "show": 0,
                    "add": 0,
                    "edit": 0,
                    "delete": 0
                }
            }
        },
    }),
    created: function () {
        window.V = this;
    },
    mounted: function(){
        window.Vfc = this.$children[0];
    }
})

axios.defaults.headers['X-Version'] = API.apiVersion;

axios.defaults.headers.Accept = "application/json";

axios.interceptors.response.use(
    function (response) {
        tarteaucitron.toggleIcon();
        return response;
    },
    function (error) {
        if (error.response && 401 === error.response.status) {
            if(error.response && error.response.data && error.response.data.message == 'invalid_credentials'){
                window.loginError = "Vos identifiants et/ou mot de passe ne sont pas valides";
            }
            else{
                delete axios.defaults.headers.Authorization;
                Auth.getRefreshToken(function(token){
                  axios.defaults.headers.Authorization = "Bearer "+token;
                  error.config.headers.Authorization = 'Bearer '+token;
                  return axios.request(error.config);
                }, function(){
                  Auth.logout();
                  window.V._router.push('/login');
                })
            }
            return Promise.reject(error);
        } else if (error.response && 400 === error.response.status) {
            // Si le message contient des espaces, c'est un message clair et pas un code ?
            if (error.response.data.message && error.response.data.message.includes(' ')) {
              window.Vfc.$refs.messages.sendMessage('error',error.response.data.message);
            }
            if (window.V._router.app._route.meta.fallback) {
                window.V._router.push(window.V._router.app._route.meta.fallback);
            }
            return Promise.reject(error);
        } else if (error.response && 404 === error.response.status) {
            if(router.app._route.name != 'TOSForm') { //Seul solution pour gérer la 404 localement via axios
                if (router.app._route.query.fromRegistration && router.app._route.query.fromRegistration == 1) {
                    window.Vfc.$refs.messages.sendMessage('info', window.V.$i18n.t('errors.registrationfailed') + '<i class="fa fa-hashtag"></i>' + Utils.pad(router.app._route.params.id, '0', 8));
                    window.V._router.push('/devices/licences');
                }
            } else {
                window.Vfc.$refs.messages.sendMessage('error', window.V.$i18n.t('errors.e404'));
                if (window.V._router.app._route.meta.fallback) {
                    window.V._router.push(window.V._router.app._route.meta.fallback);
                }
            }
            return Promise.reject(error);
        } else if (error.response && 500 === error.response.status) {
            window.Vfc.$refs.messages.sendMessage('error',window.V.$i18n.t('errors.e500') + ' ' + error.response.data.message);
            if (window.V._router.app._route.meta.fallback) {
                window.V._router.push(window.V._router.app._route.meta.fallback);
            }
            return Promise.reject(error);
        } else if (error.response && 403 === error.response.status) {
            window.Vfc.$refs.messages.sendMessage('error',window.V.$i18n.t('errors.e403') + ' ' + error.response.data.message);
            if (window.V._router.app._route.meta.fallback) {
                window.V._router.push(window.V._router.app._route.meta.fallback);
            }
            return Promise.reject(error);
        } else if (error.response && 402 === error.response.status) {
            window.Vfc.$refs.messages.sendMessage('error',window.V.$i18n.t('errors.e402') + ' ' + error.response.data.message);
            Auth.logout();
            window.V._router.push('/login');
            return Promise.reject(error);
        }else {
            return Promise.reject(error);
        }
    });

Vue.filter('two_digits', function (value) {
    if(value != null){
        if(value.toString().length <= 1)
        {
            return "0"+value.toString();
        }
        return value.toString();
    }
    return '';
});

Vue.filter('only_date', function(value){
    if(value != null){
        if(typeof value == 'string'){
            return moment(value).format(Utils.t('datetime.date'));
        }
        if(typeof value == 'object'){
            return moment(value.date).tz(value.timezone).format(Utils.t('datetime.date'));
        }
    }
    return '';
});

Vue.filter('only_time', function(value){
    if(value != null){
        if(typeof value == 'string'){
            return moment(value).format('HH:mm');
        }
        if(typeof value == 'object'){
            return moment(value.date).tz(value.timezone).format('HH:mm');
        }
    }
    return '';
});

API.apiBaseURL = (localStorage.getItem('dev_api')!==null) ? localStorage.getItem('dev_api') :  process.env.BASE_API_URL;

//SERVICE WORKER

(function() {
    if('serviceWorker' in navigator) {
        navigator.serviceWorker.register('/sw.js');
    }
})();
